<template>
    <div class="account-vip-page">
        <el-card class="basic-card" shadow="never">
            <div slot="header" class="flex flex-align-center" style="border-radius: 0 10px 0 0;">
                <div class="flex-1">
                    <div class="flex flex-align-center">
                        <div><vip-icon></vip-icon></div>
                        <div class="margin-l-10">
                            <span class="fonts-16 text-weight-600">{{userInfo.accountTypeDesc}}</span>
                            <span class="fonts-14 margin-l-10" v-if="['personal', 'pro-limited'].indexOf(userInfo.accountType) < 0 && userInfo.expireTime">{{$t('account.Vip_page_tips_1', {date: moment(userInfo.expireTime).format('YYYY-MM-DD')})}}</span>
                            <span class="fonts-12 color-error margin-l-10" v-if="userInfo.accountType === 'pro-limited'">{{$t('account.Vip_page_tips_2')}}</span>
                        </div>
                    </div>
                    <div class="fonts-12 color-808080 margin-t-10" v-if="['personal', 'pro-limited'].indexOf(userInfo.accountType)>-1">{{$t('account.Vip_page_tips_3')}}</div>
                </div>
            </div>
            <div class="flex flex-justify-between ">
                <div>
                    <div class="fonts-12">
                        <span class="fonts-17 text-weight-600">{{$t('account.Vip_page_tips_4')}}</span>
                        <span class="margin-l-10">{{$t('account.Vip_page_tips_5', {type: userInfo.accountTypeDesc})}}</span>
                        <router-link to="/account/chars" class="margin-l-10">{{$t('account.Vip_page_tips_6')}}</router-link>
                    </div>
                    <div class="margin-t-18" v-if="userInfo.accountType === 'internal'"><span class="fonts-15">{{$t('account.Vip_page_tips_7')}}</span></div>
                    <div class="margin-t-18 fonts-15" v-else><span>{{$t('account.Vip_page_tips_8', {surplus: userInfo.flowQuota.surplus})}}</span><span class="color-808080"> / {{$t('account.Vip_page_tips_9', {total: userInfo.flowQuota.limit})}}</span></div>
                </div>
                <div>
                    <el-button plain round size="small" icon="el-icon-plus" @click="showCharDialog('c10')">{{$t('account.Vip_page_tips_10')}}</el-button>
                </div>
            </div>
            <div class="margin-t-15" v-if="userInfo && userInfo.accountType === 'internal'">
                <el-progress :percentage="100" color="#00D959" :show-text="false"></el-progress>
            </div>
            <div class="margin-t-15" v-if="userInfo && userInfo.accountType !== 'internal'">
                <el-progress :percentage="(userInfo.flowQuota.surplus/userInfo.flowQuota.limit)*100 || 0" color="#00D959" :show-text="false"></el-progress>
            </div>
        </el-card>
        <!-- <div class="margin-t-20 margin-b-20 text-weight-600">版本对比</div> -->
        <div class="flex flex-justify-center margin-y-20">
            <div class="type-list">
                <div :class="['item', activeType==='vip'?'active':'' ]" @click="activeType='vip'">{{$t('account.Vip_page_tips_11')}}</div>
                <div :class="['item', activeType==='char'?'active':'' ]" @click="activeType='char'">{{$t('account.Vip_page_tips_12')}}</div>
            </div>
        </div>
        <template v-if="userInfo && userInfo.accountType">
            <div class="vip-type-list" v-if="activeType==='vip'">
                <template v-for="(item, index) in purchaseOptions">
                    <div :key="index" class="item basic-card flex flex-column relative" :class="`bg-${item.type.toLocaleLowerCase()}`">
                        <div class="flex-1">
                            <div class="flex flex-align-center flex-justify-center">
                                <div class="vip-icon" :class="item.type.toLocaleLowerCase()">
                                    <svg-icon :name="`ic-${item.type.toLocaleLowerCase()}`"></svg-icon>
                                </div>
                            </div>
                            <div class="fonts-20 text-weight-700 flex flex-align-center flex-justify-center margin-b-30 margin-t-10">
                                <span>{{item.title}}</span>
                            </div>
                            <template v-for="(detail, dIndex) in item.details">
                                <div class="flex flex-align-center fonts-14 margin-b-16" :key="dIndex">
                                    <svg-icon name="ib-check-o" className="color-success"></svg-icon>
                                    <span class="margin-l-10 flex-1">{{detail.main}}<div class="fonts-12 color-919191 margin-t-4" v-if="detail.secondary">{{detail.secondary}}</div></span>
                                </div>
                            </template>
                        </div>
                        <!-- <template v-if="item.type.toLocaleLowerCase() === 'pro'">
                            <div class="tag">限时买1得1</div>
                            <div class="text-center fonts-12">
                                <a href="https://mp.weixin.qq.com/s/y3N4rxEnKkdIrAdPT3Y_Ow" target="_blank" class="color-error">
                                    买1得1，点击查看618活动详情🎉
                                </a>
                            </div>
                        </template> -->
                        <div class="text-center margin-t-14">
                            <el-button plain round size="medium" @click="applyBtnEvent(item)" v-if="item.showApplyBtn">{{$t('account.Vip_page_tips_13')}}</el-button>
                            <el-button plain round size="medium" style="border-color: #2979FF;color: #2979FF;" @click="auditingBtnEvent(item)" v-if="item.showAuditingBtn">{{$t('account.Vip_page_tips_14')}}</el-button>
                            <el-button plain round size="medium" @click="purchaseBtnEvent(item)" v-if="item.showPurchaseBtn">{{$t('account.Vip_page_tips_15')}}</el-button>
                            <el-button plain round size="medium" @click="renewBtnEvent(item)" v-if="item.showRenewBtn">{{$t('account.Vip_page_tips_16')}}</el-button>
                            <el-button plain round size="medium" @click="applyBtnEvent(item)" v-if="item.showContactBtn">{{$t('account.Vip_page_tips_17')}}</el-button>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <div class="chars-pakage-list" v-if="activeType==='char'">
            <div class="item basic-card flex flex-column">
                <div class="char-wapper">
                    <div class="char-icon icon-m">
                        <svg-icon name="ib-word-package"></svg-icon>
                    </div>
                    <div class="text-center fonts-17 text-weight-600 margin-t-10">{{$t('account.Vip_page_tips_18', {number: 10})}}</div>
                    <div class="text-center fonts-15 text-weight-600 margin-t-15">{{$t('account.Vip_page_tips_19', {price: 60})}}<!-- <span class="line-through margin-l-10 fonts-14 color-919191">￥19元</span> --></div>
                    <div class="text-center fonts-14 margin-t-8 color-919191 padding-x-10">{{$t('account.Vip_page_tips_20', {price: 6})}}</div>
                </div>
                <div class="text-center" style="margin-top: 21px;">
                    <el-button plain round size="medium" @click="showCharDialog('c10')">{{$t('account.Vip_page_tips_21')}}</el-button>
                </div>
            </div>
            <div class="item basic-card flex flex-column">
                <div class="char-wapper">
                    <div class="char-icon icon-m">
                        <svg-icon name="ib-word-package"></svg-icon>
                    </div>
                    <div class="text-center fonts-17 text-weight-600 margin-t-10">{{$t('account.Vip_page_tips_18', {number: 50})}}</div>
                    <div class="text-center fonts-15 text-weight-600 margin-t-15">{{$t('account.Vip_page_tips_19', {price: 200})}}<!-- <span class="line-through margin-l-10 fonts-14 color-919191">￥59元</span> --></div>
                    <div class="text-center fonts-14 margin-t-8 color-919191 padding-x-10">{{$t('account.Vip_page_tips_20', {price: 4})}}</div>
                </div>
                <div class="text-center" style="margin-top: 21px;">
                    <el-button plain round size="medium" @click="showCharDialog('c50')">{{$t('account.Vip_page_tips_21')}}</el-button>
                </div>
            </div>
            <div class="item basic-card flex flex-column">
                <div class="char-wapper">
                    <div class="char-icon icon-m">
                        <svg-icon name="ib-word-package"></svg-icon>
                    </div>
                    <div class="text-center fonts-17 text-weight-600 margin-t-10">{{$t('account.Vip_page_tips_18', {number: 100})}}</div>
                    <div class="text-center fonts-15 text-weight-600 margin-t-15">{{$t('account.Vip_page_tips_19', {price: 360})}}<!-- <span class="line-through margin-l-10 fonts-14 color-919191">￥99元</span> --></div>
                    <div class="text-center fonts-14 margin-t-8 color-919191 padding-x-10">{{$t('account.Vip_page_tips_20', {price: 3.6})}}</div>
                </div>
                <div class="text-center" style="margin-top: 21px;">
                    <el-button plain round size="medium" @click="showCharDialog('c100')">{{$t('account.Vip_page_tips_21')}}</el-button>
                </div>
            </div>
            <div class="item basic-card flex flex-column">
                <div class="char-wapper">
                    <div class="char-icon icon-l">
                        <svg-icon name="ib-word-package"></svg-icon>
                    </div>
                    <div class="text-center fonts-17 text-weight-600 margin-t-10">{{$t('account.Vip_page_tips_18', {number: 1000})}}</div>
                    <div class="text-center fonts-15 text-weight-600 margin-t-15">{{$t('account.Vip_page_tips_19', {price: 3200})}}<!-- <span class="line-through margin-l-10 fonts-14 color-919191">￥99元</span> --></div>
                    <div class="text-center fonts-14 margin-t-8 color-919191 padding-x-10">{{$t('account.Vip_page_tips_20', {price: 3.2})}}</div>
                </div>
                <div class="text-center" style="margin-top: 21px;">
                    <el-button plain round size="medium" @click="showCharDialog('c1000')">{{$t('account.Vip_page_tips_21')}}</el-button>
                </div>
                <!-- <div class="tag erp">企业版</div> -->
            </div>
            <div class="item basic-card flex flex-column">
                <div class="char-wapper">
                    <div class="char-icon icon-l">
                        <svg-icon name="ib-word-package"></svg-icon>
                    </div>
                    <div class="text-center fonts-17 text-weight-600 margin-t-10">{{$t('account.Vip_page_tips_23')}}</div>
                    <!-- <div class="text-center fonts-15 text-weight-900 margin-t-15">&nbsp;</div>
                    <div class="text-center fonts-14 margin-t-8 color-919191 padding-x-10">&nbsp;</div> -->
                </div>
                <div class="text-center" style="margin-top: 80px;">
                    <el-button plain round size="medium" @click="connectUsEvent">{{$t('account.Vip_page_tips_22')}}</el-button>
                </div>
                <!-- <div class="tag erp">企业版</div> -->
            </div>
        </div>
        <template v-if="activeType === 'vip'">
            <div class="fonts-12 line-height-1.25 padding-20" style="color: #8A8A8A;">
                *<a target="blank" href="https://m15er90ta0.feishu.cn/wiki/Wc4KwKWq6i7PeKkJm38cbUtXnmf">{{$t('account.Vip_page_tips_29')}}</a>
            </div>
        </template>
        <template v-if="activeType === 'char'">
            <div class="fonts-12 line-height-1.25 padding-20" style="color: #8A8A8A;">
                {{$t('account.Vip_page_tips_24')}}
                <a target="blank" href="https://m15er90ta0.feishu.cn/docx/Yb9XdJZxGoh4vaxlNCwcv9UQnjb">
                    {{$t('account.Vip_page_tips_25')}}
                </a>
                {{$t('account.Vip_page_tips_26')}}
            </div>
        </template>
        <el-dialog :title="$t('account.Vip_page_dialog_1_title')" :visible.sync="trialDialog.show" destroy-on-close width="440px" top="20px">
            <div class="text-center padding-l-30 padding-r-30" style="line-height:1.5;">{{$t('account.Vip_page_dialog_1_tips_1')}}</div>
            <div slot="footer" style="text-align: center;">
                <el-button round plain size="small" @click="cancelTrialBtnEvent">{{$t('account.Vip_page_dialog_1_btn_1')}}</el-button> 
                <el-button round type="primary" size="small" :loading="trialDialog.loading" @click="submitTrialBtnEvent">{{$t('account.Vip_page_dialog_1_btn_2')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('account.Vip_page_dialog_2_title')" :visible.sync="contactUsDialog.show" destroy-on-close @closed="handlerContactUsDialogClose" class="none-padding-body" width="430px" top="20px">
            <div v-if="contactUsDialog.submitted">
                <div class="color-success fonts-24 margin-t-15 text-center">
                    <i class="el-icon-success"></i>
                </div>
                <div class="fonts-15 margin-t-15 text-center">{{$t('account.Vip_page_dialog_2_tips_1')}}</div>
                <div class="fonts-12 margin-t-10 text-center">{{$t('account.Vip_page_dialog_2_tips_2')}}</div>
                <div class="fonts-12 margin-t-10 text-center">{{$t('account.Vip_page_dialog_2_tips_3')}}</div>
                <div class="text-center margin-t-10">
                <template v-if="contactUsDialog.form.edition === 'TRIAL'">
                    <img :src="selectOptions.contactQrCode[0].option" class="border-default radius-10 padding-5" alt="wechat qrcode" style="width: 142px;"/>
                </template>
                <template v-else>
                    <img src="../../../static/images/account/tencent-oa-qrcode-1.png" class="border-default radius-10" alt="wechat qrcode" style="width: 142px;"/>
                </template>
                </div>
            </div>
            <template v-else>
                <div class="fonts-12 bg-fdf6e7 padding-y-8 color-warning text-center">{{$t('account.Vip_page_dialog_2_tips_4')}}</div>
                <el-form size="medium" class="margin-t-10" style="padding: 0 60px;">
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_1_label')" required class="margin-b-20">
                        <el-input v-model="contactUsDialog.form.contact" maxlength="50" show-word-limit :placeholder="$t('account.Vip_page_dialog_2_placeholder_1')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_2_label')" required class="margin-b-20" v-if="contactUsDialog.form.edition === 'ULTIMATE'">
                        <el-input v-model="contactUsDialog.form.title" maxlength="50" show-word-limit :placeholder="$t('account.Vip_page_dialog_2_placeholder_2')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_3_label')" required class="margin-b-20">
                        <el-input v-model="contactUsDialog.form.phone" maxlength="50" show-word-limit :placeholder="$t('account.Vip_page_dialog_2_placeholder_3')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_4_label')" required class="margin-b-20">
                        <el-input v-model="contactUsDialog.form.email" maxlength="50" show-word-limit :placeholder="contactUsDialog.form.edition === 'TRIAL' ? $t('account.Vip_page_dialog_2_placeholder_4_1') : $t('account.Vip_page_dialog_2_placeholder_4_2')"></el-input>
                    </el-form-item>
                    <el-form-item :label="contactUsDialog.form.edition === 'TRIAL' ? $t('account.Vip_page_dialog_2_form_item_5_label_1') : $t('account.Vip_page_dialog_2_form_item_5_label_2')" required class="margin-b-20">
                        <el-input v-model="contactUsDialog.form.name" maxlength="50" show-word-limit :placeholder="contactUsDialog.form.edition === 'TRIAL' ? $t('account.Vip_page_dialog_2_placeholder_5_1') : $t('account.Vip_page_dialog_2_placeholder_5_2')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_6_label')" required class="margin-b-20" v-if="contactUsDialog.form.edition === 'ULTIMATE'">
                        <el-input v-model="contactUsDialog.form.course" maxlength="50" show-word-limit :placeholder="$t('account.Vip_page_dialog_2_placeholder_6')"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="机构类型" required class="margin-b-20">
                        <el-select v-model="contactUsDialog.form.orgType" placeholder="请选择机构类型" style="width: 100%;">
                            <template v-for="item in selectOptions.orgType">
                                <el-option :label="item.display" :value="item.option" :key="item.option"></el-option>
                            </template>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_7_label')" required class="margin-b-20">
                        <el-select v-model="contactUsDialog.form.orgScale" :placeholder="$t('account.Vip_page_dialog_2_placeholder_7')" style="width: 100%;">
                            <template v-for="item in selectOptions.orgScale">
                                <el-option :label="item.display" :value="item.option" :key="item.option"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('account.Vip_page_dialog_2_form_item_8_label')" required class="margin-b-20">
                        <el-input v-model="contactUsDialog.form.businessScene" type="textarea" rows="5" :placeholder="$t('account.Vip_page_dialog_2_placeholder_8')"></el-input>
                    </el-form-item>
                    <el-form-item required class="margin-b-20" v-if="contactUsDialog.form.edition === 'ULTIMATE'">
                        <span class="fonts-14 zindex-10" style="color: #606266; line-height: 36px;"><span style="color: #F56C6C;margin-right: 4px;">*</span>{{$t('account.Vip_page_dialog_2_tips_5')}}<span><a :href="`https://nextcat-dev.oss-cn-beijing.aliyuncs.com/files/public/LanguageX高校试用申请表样例.docx?ttt=${new Date().getTime()}`" class="margin-l-15 cursor-pointer">{{$t('account.Vip_page_dialog_2_tips_6')}}</a></span></span>
                        <upload-oss ref="uploadTableNode" :title="$t('account.Vip_page_dialog_2_tips_7')" accept=".doc,.docx"></upload-oss>
                    </el-form-item>
                </el-form>
            </template>
            <div slot="footer" class="text-center" v-if="contactUsDialog.submitted">
                <el-button type="primary" size="mini" round @click="contactUsDialog.show = false;">{{$t('account.Vip_page_dialog_2_btn_1')}}</el-button>
            </div>
            <div slot="footer" class="text-center" v-else>
                <el-button size="mini" plain round @click="contactUsDialog.show = false">{{$t('account.Vip_page_dialog_2_btn_2')}}</el-button>
                <el-button type="primary" size="mini" round :loading="contactUsDialog.loading" @click="submitContactsForm">{{$t('account.Vip_page_dialog_2_btn_1')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('account.Vip_page_dialog_3_title')" :visible.sync="contactUsDialog.qrcodeShow" destroy-on-close width="430px" top="20px">
            <div class="color-success fonts-20 text-center">
                <i class="el-icon-success"></i>
            </div>
            <div class="fonts-12 margin-t-15 text-center">{{$t('account.Vip_page_dialog_3_tips_1')}}</div>
            <div class="fonts-12 margin-t-10 text-center">{{$t('account.Vip_page_dialog_3_tips_2')}}</div>
            <div class="text-center margin-t-10">
                <img src="../../../static/images/account/tencent-oa-qrcode.jpg" class="border-default radius-10" alt="wechat qrcode" style="width: 142px;"/>
            </div>
            <div slot="footer" class="text-center">
                <el-button type="primary" size="mini" round @click="contactUsDialog.qrcodeShow = false">{{$t('account.Vip_page_dialog_3_btn_1')}}</el-button>
            </div>
        </el-dialog>
        <alert-dialog ref="bindPhoneNode" :message="$t('account.Vip_page_tips_27')" type="confirm" :buttonName="$t('account.Vip_page_tips_28')" @confirmEvent="toBindPhoneEvent"></alert-dialog>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import tools from "@/utils/tools";
import { commonApi, userApi, orgApi } from "@/utils/api";
import VipIcon from "@/components/icon/VipIcon";
import VipCheck from "@/components/icon/VipCheck";
import AlertDialog from '@/components/AlertDialog';
import UploadOss from '@/components/UploadOss';
export default {
    components: { VipIcon, VipCheck, AlertDialog, UploadOss, },
    data() {
        return {
            tools, 
            moment,
            trialDialog: {
                show: false,
                loading: false,
            },
            activeType: 'vip', //char
            contactUsDialog: {
                qrcodeShow: false,
                show: false,
                loading: false,
                submitted: false,
                form: {
                    name: '',
                    email: '',
                    contact: '',
                    phone: '',
                    edition: '',
                    orgScale: '',
                    businessScene: '',
                    title: '',
                    course: '',
                }
            },
            purchaseOptions: [],
            selectOptions: {},
        }
    },
    computed: {
		...mapState({
			userInfo: state => state.user.userData,
		}),
	},
    created() {
        this.initPurchaseOptions();
        this.initApplyFormSelectOptions();
        let query = this.$route.query;
        if(this.userInfo.accountType === 'personal' && query.view === 'trial'){
            this.trialDialog.show = true;
        }
        if(query.view === 'char'){
            this.activeType = 'char';
            if(query.child){
                this.$nextTick(()=>{
                    this.showCharDialog(query.child === 'true' ? 'c10' : query.child);
                });
            }
        }
    },
    methods: {
        payProBtnEvent(){
            if (this.userInfo.accountType === 'personal'){
                this.trialDialog.show = true;
            }else if (['pro-trial','pro','pro-limited'].indexOf(this.userInfo.accountType)>-1){
                this.$store.dispatch('pay/setPayDialogAction',{show:true});
            }
        },
        // 申请试用
        applyBtnEvent(item) {
            if (item.type === 'Pro') {
                this.trialDialog.show = true;
            }else if (item.type === 'ENTERPRISE') {
                this.contactUsDialog.form.edition = 'TRIAL';
                this.applyEnterpriseEvent();
            }else if (item.type === 'ULTIMATE') {
                this.contactUsDialog.form.edition = 'ULTIMATE';
                this.applyEnterpriseEvent();
            }
        },
        // 审核中
        auditingBtnEvent(item) {
            if (item.type === 'ENTERPRISE') {
                this.contactUsDialog.qrcodeShow = true;
            }
        },
        // 立即购买
        purchaseBtnEvent(item) {
            if (item.type === 'Pro') {
                this.$store.dispatch('pay/setPayProDialogAction',{show: true});
            }else if (item.type === 'ENTERPRISE') {
                if(this.userInfo.phone){
                    this.$store.dispatch('pay/setPayErpDialogAction',{show: true});
                }else {
                    this.$refs.bindPhoneNode.setShow(true);
                }
            }
        },
        // 立即续费
        renewBtnEvent(item) {
            if (item.type === 'Pro') {
                this.$store.dispatch('pay/setPayProDialogAction',{show: true});
            }else if (item.type === 'ENTERPRISE') {
                 this.$store.dispatch('pay/setPayErpDialogAction',{show: true});
            }
        },
        cancelTrialBtnEvent(){
            this.trialDialog.show = false;
            this.$router.replace('/account/vip');
        },
        submitTrialBtnEvent(){
            let url = userApi.getProTrial;
            this.$ajax.post(url,{}).then(res=>{
                if(res.status === 200){
                    this.$message.success(this.$t('account.Vip_page_method_submitTrialBtnEvent_message_1'));
                    this.trialDialog.show = false;
                    this.$store.dispatch("user/queryUserInfoAction");
                    setTimeout(()=>{
                        location.reload(true);
                    },1500);
                }
            })
        },
        showCharDialog(type){
            this.$store.dispatch('pay/setCharDialog',{show:true, type});
        },
        handlerContactUsDialogClose(){
            this.contactUsDialog = this.$options.data().contactUsDialog;
        },
        applyEnterpriseEvent(){
            if(this.userInfo.phone){
                this.contactUsDialog.show = true;
                this.initApplyFormSelectOptions();
            }else {
                this.$refs.bindPhoneNode.setShow(true);
            }
        },
        toBindPhoneEvent(){
            this.$router.push('/account/index');
        },
        submitContactsForm(){
            if(!this.contactUsDialog.form.contact){
                this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_1'));
                return;
            }
            if(!this.contactUsDialog.form.phone){
                this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_2'));
                return;
            }else{
                if(!tools.checkPhone(this.contactUsDialog.form.phone)){
                    this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_3'));
                    return;
                }
            }
            if(!this.contactUsDialog.form.email){
                this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_4'));
                return;
            }else{
                if(!tools.checkEmail(this.contactUsDialog.form.email)){
                    this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_5'));
                    return;
                }
            }
            if(!this.contactUsDialog.form.name){
                this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_6'));
                return;
            }
            
            if(!this.contactUsDialog.form.orgScale){
                this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_7'));
                return;
            }
            if(!this.contactUsDialog.form.businessScene){
                this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_8'));
                return;
            }
            let tableFiles = [];
            if(this.contactUsDialog.form.edition === 'ULTIMATE') {
                tableFiles = this.$refs.uploadTableNode.getOssFiles();
                if(!this.contactUsDialog.form.title){
                    this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_9'));
                    return;
                }
                if(!this.contactUsDialog.form.course){
                    this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_10'));
                    return;
                }
                if(tableFiles.length === 0){
                    this.$message.error(this.$t('account.Vip_page_method_submitContactsForm_message_11'));
                    return;
                }
            }
            
            let postData= {
                name: this.contactUsDialog.form.name,
                email: this.contactUsDialog.form.email,
                contact: this.contactUsDialog.form.contact,
                phone: this.contactUsDialog.form.phone,
                edition: this.contactUsDialog.form.edition,
                orgScale: this.contactUsDialog.form.orgScale,
                businessScene: this.contactUsDialog.form.businessScene,
            }
            if(this.contactUsDialog.form.edition === 'ULTIMATE') {
                postData = {
                    ...this.contactUsDialog.form,
                };
                postData.objectName = tableFiles[0].objectName;
            }
            this.contactUsDialog.loading = true;
            this.$ajax.post(orgApi.submitApplyTrial, postData).then(res => {
                if(res.status === 200){
                    console.log(this.contactUsDialog);
                    this.contactUsDialog.submitted = true;
                    this.initPurchaseOptions();
                }
            }).finally(() => {
                this.contactUsDialog.loading = false;
            })
            
        },
        connectUsEvent(){
            location.href = 'mailto:languagex@besteasy.com';
        },
        initPurchaseOptions () {
            this.$ajax.get(commonApi.queryPurchaseOptions).then(res => {
                if(res.status === 200){
                    this.purchaseOptions = res.data;
                }
            });
        },
        initApplyFormSelectOptions () {
            this.$ajax.get(commonApi.queryApplyFormSelectOptions).then(res => {
                if(res.status === 200){
                    this.selectOptions = res.data;
                }
            });
        }
    },
    mounted() {
        
    }
}
</script>
<style lang="scss" scoped>
.account-vip-page{
    .basic-card {
        box-shadow: initial;
    }
    .type-list{
        display: flex;
        background-color: #E5E5E5;
        box-sizing: border-box;
        // border: 1px solid rgba(0, 0, 0, 0.2);
        // box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
        border-radius: 50px;
        .item{
            min-width: 90px;
            padding: 0 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
            height: 36px;
            color: #212121;
            font-size: 15px;
            cursor: pointer;
            &.active{
                background-color: #212121;
                color: #ffffff;
            }
        }
    }
    .vip-type-list{
        padding: 0 20px;
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
        .item{
            position: relative;
            padding: 30px 20px;
            // background-color: #fcfdce;
            min-height: 395px;
            .vip-icon{
                width: 40px;
                height: 40px;
                border-radius: 50px;
                font-size: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                &.free{
                    background-color: #F2F2F2;
                }
                &.pro{
                    background-color: #FFEBC4;
                }
                &.enterprise{
                    background-color: #DFD7F8;
                }
                 &.ultimate{
                    background-color: #C3D6FD;
                }
            }
            .tag{ 
                border-radius: 0 10px 0 10px;
                background-color: #F56C6C;
                padding: 0 10px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                font-size: 12px;
                color: #FFFFFF;
                position: absolute;
                top: 0;
                right: 0;                       

            }
            &.bg-free {
                background-color: #F8F8F8;
            }
            &.bg-pro {
                background-color: #FFF5E1;
            }
            &.bg-enterprise {
                background-color: #EFEBFB;
            }
            &.bg-ultimate {
                background-color: #E4E9FF;
            }
        }
    }
    .bg-current-version{
        position: absolute;
        left: 0;
        top: 0;
        background-image: url(../../../static/images/account/current-version.png);
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: contain;
        width: 66px;
        height: 66px;
    }
    .bg-left{
        background-image: url(../../../static/images/account/vip-bg-left.png);
        background-position: bottom;
        background-repeat: no-repeat;
    }
    .bg-center{
        background-image: url(../../../static/images/account/vip-bg-center.png);
        background-position: bottom;
        background-repeat: no-repeat;
    }
    .bg-right{
        background-image: url(../../../static/images/account/vip-bg-right.png);
        background-position: bottom;
        background-repeat: no-repeat;
    }
    .chars-pakage-list{
        padding: 0 20px;
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
        .item{
            display: flex;
            position: relative;
            align-items: center;
            flex-direction: column;
            background-color: #F8F8F8;
            min-height: 238px;
            .char-wapper {
                margin-top: 30px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .char-icon{
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 23px;
                border-radius: 50px;
                background-color: #CCF7DE;
                color: #00D959;
            }
            .tag {
                border-radius: 0 10px 0 10px;
                background-color: #F56C6C;
                width: 48px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                font-size: 12px;
                color: #FFFFFF;
                position: absolute;
                top: -1px;
                right: -1px;
                &.erp {
                    background-color: #AA84DA;
                }
            }
            &.bg-yellow{
                background-color: #FFF5E1;
            }
            &.bg-purple{
                background-color: #EFEBFB;
            }
        }
    }
}
</style>
